import React, { useEffect, useRef, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import moment from "moment";
import CustomToolbar from "../components/CustomToolbar";
import Events from "../components/Events";
import "../css/appointment.css";
import { EventMonth } from "../components/EventMonth";
import EventAgenda from "../components/EventAgenda";
import "../css/OldAppointment.css";
import { useMediaQuery } from "react-responsive";
import { dateConvertToPayloadBookingFormat } from "../../../components/admin/setup/helper/Helper";
import {
  useCreateItem,
  useDeleteItem,
  useSecureUpdateItem,
  useUpdateItem,
} from "../../../_helper/actions/mutation/items";
import { ApiEndPoint } from "../../../_helper/constant/api-types";
import { toast } from "react-toastify";
import EditPatientDetail from "../components/EditPatientDetail";
import RescheduleAppointment from "../components/RescheduleAppointment";
import {
  getDateInputFormat,
  getTotalAppointmentsInMonth,
} from "../../_helper/utils.js/utils";
import { useNavigate, useSearchParams } from "react-router-dom";
import EventsSm from "../components/EventsSm";
import { BookEvent } from "../components/BookEvent";
import Swipeable from "../../../common_component/component/Swipeable";
import { useCurrentRole } from "../../../_helper/constant/Permission";
import Confirmation from "../../../common_component/component/Confirmation";
import CuModal from "../../../common_component/component/CuModal";
import { useAtom } from "jotai";
import {
  clinicAtom,
  permissionAtom,
} from "../../../_helper/constant/constant-atom";
import { useItemsFilterNew } from "../../../_helper/actions/app/items";
import CuMobileModal from "../../../all-patient/components/CuMobileModal";
import Invoice from "../../../mobile_invoice/views/Invoice";
import EmailTemplate from "../../../credit_invoice/components/EmailTemplate";
import PreConsultation from "../components/PreConsultation";

const MyCalendar = React.memo(
  ({
    events,
    isJumpDate,
    setIsJumpDate,
    dayCycle,
    userViewID,
    selectedDoctor,
    selectedSession,
    setSelectedSession,
    totalAppointments,
    isSearchOpen,
    setIsSearchOpen,
    bookAppointment,
    clinic_id,
    role_id,
    date,
    isCustomSession,
    setIsCustomSession,
    customSessionData,
    setCustomSessionData,
    setDate,
    allClinic,
    setAllClinic,
    // isOnline,
    connectWebSocket,
  }) => {
    const localizer = momentLocalizer(moment);
    const [searchParams, setSearchParams] = useSearchParams();
    const calendarRef = useRef();
    const navigate = useNavigate();
    const [permission] = useAtom(permissionAtom);
    // const [scrollPosition, setScrollPosition] = useState(0);
    // const [selectedUser, setSelectedUser] = useState(null);
    const { bhp_registered_clinic } = useCurrentRole();
    const [clinicOptions, setClinicOptions] = useState();
    const [selectedClinicOption, setSelectedClinicOption] = useState();
    const [, setClinic] = useAtom(clinicAtom);
    const [isInvoice, setIsInvoice] = useState({ data: null, flag: false });
    const [isPrint, setIsPrint] = useState({ data: null, flag: false });
    const [editDetailModal, setEditDetailModal] = useState({
      data: null,
      flag: false,
    });
    const [isReschedule, setIsReschedule] = useState({
      data: null,
      flag: false,
    });
    const [isPreconsultation, setIsPreconsultation] = useState({
      data: null,
      flag: false,
    });
    const [isMobileModal, setIsMobileModal] = useState({
      flag: false,
      event: null,
    });
    const [isOpen, setIsOpen] = useState({
      flag: false,
      startTime: "",
      type: "walkin",
      manualTime: false,
    });
    const [onclktime, setOnclktime] = useState();
    const [start_date, setStart_date] = useState();
    const [isSwitchClinic, setIsSwitchClinic] = useState({
      flag: false,
      clinicId: null,
    });

    const blockedSlotMutation = useCreateItem(ApiEndPoint?.QM_SC_SLOTS);
    const unblock_mutation = useDeleteItem(ApiEndPoint?.QM_SC_SLOTS);
    const deleteSlotMutation = useDeleteItem(ApiEndPoint?.QM_SC_SLOTS);

    const openModal = () =>
      setIsOpen({ flag: true, startTime: "", type: "walkin" });

    const [totalAppointmentsOnMonth, setAppointment] = useState();

    useEffect(() => {
      const data = events;
      const result = getTotalAppointmentsInMonth(data);
      setAppointment(result[0].month);
    }, [events]);

    useEffect(() => {
      if (bhp_registered_clinic) {
        const transformedData = bhp_registered_clinic?.map((item) => ({
          key: item.id,
          value: item.id,
          text: item.clinic_name,
        }));
        setClinicOptions(transformedData);
        setSelectedClinicOption(clinic_id);
      }
    }, [clinic_id]);

    useEffect(() => {
      const handleTimeSlotClick = (event) => {
        const label = event.currentTarget.querySelector(".rbc-label");
        if (label) {
          const innerHTML = label.innerHTML;
          const [time, period] = innerHTML.split(" ");
          const [hoursStr, minutesStr] = time.split(":");
          let hours = parseInt(hoursStr, 10);
          const minutes = parseInt(minutesStr, 10);

          // Convert to 24-hour format
          if (period === "PM" && hours !== 12) {
            hours += 12;
          } else if (period === "AM" && hours === 12) {
            hours = 0;
          }

          // Format the hours and minutes as two-digit strings
          const hours24hr = hours.toString().padStart(2, "0");
          const minutes24hr = minutes.toString().padStart(2, "0");

          // Concatenate the hours and minutes
          const time24hr = `${hours24hr}:${minutes24hr}`;
          const wholetime = `${start_date}`;
          setOnclktime({ slotinfo: wholetime, time: time24hr });
        }

        openModal();
      };

      const timeSlots = document.getElementsByClassName("rbc-time-slot");

      Array.from(timeSlots).forEach((slot) => {
        slot.addEventListener("click", handleTimeSlotClick);
      });

      return () => {
        Array.from(timeSlots).forEach((slot) =>
          slot.removeEventListener("click", handleTimeSlotClick)
        );
      };
    }, [date, dayCycle]);

    const sm = !useMediaQuery({ query: "(min-width:1024px)" });

    const handleSwitchClinic = () => {
      const selectedClinic = bhp_registered_clinic?.find(
        (clnc) => clnc?.id === isSwitchClinic?.clinicId
      );
      if (selectedClinic) {
        setClinic(selectedClinic);
        localStorage.setItem("clinic", selectedClinic?.id);
      }
      setIsSwitchClinic({ flag: false, clinicId: null });
    };

    const isSelectedClinic = (event) => {
      if (event?.clinic_id !== clinic_id) {
        setIsSwitchClinic({ flag: true, clinicId: event?.clinic_id });
        setIsMobileModal({ flag: false, event: null });
        return false;
      } else {
        return true;
      }
    };

    const handleEditPatient = (patientDetails) => {
      if (!isSelectedClinic(patientDetails)) {
        return;
      }
      setEditDetailModal({
        data: patientDetails?.user_details,
        slotId: patientDetails?.id,
        ipd: patientDetails?.ipd,
        opd: patientDetails?.opd,
        custom_field_1: patientDetails?.custom_field_1,
        flag: true,
      });

      setIsMobileModal({ flag: false, event: null });
    };

    const handleReschedule = (event) => {
      if (!isSelectedClinic(event)) {
        return;
      }
      let startHours = `${event?.start?.getHours()}`;
      let startMin = `${event?.start?.getMinutes()}`;
      if (startHours?.length === 1) {
        startHours = `0${startHours}`;
      }
      if (startMin?.length === 1) {
        startMin = `0${startMin}`;
      }
      const existingSlotData = {
        date: getDateInputFormat(event?.start),
        startTime: `${startHours}:${startMin}`,
        duration: 5,
        slotId: event?.id,
        phone: event?.user_details?.phone,
        userName: event?.user_details?.full_name,
      };
      setIsReschedule({ data: existingSlotData, flag: true });
      setIsMobileModal({ flag: false, event: null });
    };

    const handlePreConsultation = (event) => {
      if (!isSelectedClinic(event)) {
        return;
      }

      setIsPreconsultation({ data: event, flag: true });
      setIsMobileModal({ flag: false, event: null });
    };

    const postConsultation = useCreateItem(
      ApiEndPoint.QP_CM_CONSULTATION_DATA,
      ApiEndPoint.QM_SC_SLOTS
    );
    const updateConsultation = useSecureUpdateItem(
      ApiEndPoint.QP_CM_CONSULTATION_DATA,
      ApiEndPoint.QM_SC_SLOTS
    );

    const handleOpenSlotClick = (event) => {
      if (!isSelectedClinic(event)) {
        return;
      }
      if (event?.title === "open") {
        const startTime = moment(event?.start).format("HH:mm");
        const endTime = moment(event?.end).format("HH:mm");

        setIsOpen({
          flag: true,
          startTime,
          endTime: endTime,
          type: "open",
        });
      }
    };

    const handleEndConsultation = (event) => {
      if (!isSelectedClinic(event)) {
        return;
      }

      const payload = {
        action: "postConsultationData",
        frontend: "True",
        transaction_type: "OPD",
        status: "published",
        clinic_id: clinic_id,
        doctor_user: role_id,
        opd_date: moment.utc(event?.start).format("YYYY-MM-DDTHH:mm:ss[Z]"),
        personal_details: event?.user_details?.id,
        slot_id: event?.id,
        feature_name: "consultation",
      };

      postConsultation.mutate(payload, {
        onSuccess: (data) => {
          if (data?.data?.id) {
            toast.success("Slot has been successfully completed");
            setIsMobileModal({ flag: false, event: null });
          } else {
            const updatePayload = {
              id: data?.consultation_id,
              action: "patchConsultationData",
              frontend: "True",
              clinic_id: clinic_id,
              slot_id: event?.id,
              status: "published",
            };
            updateConsultation.mutate(
              { data: updatePayload, id: null },
              {
                onSuccess: () => {
                  toast.success("Slot has been successfully completed");
                  setIsMobileModal({ flag: false, event: null });
                },
                onError: (err) => {
                  toast.error(err.response.data.message);
                },
              }
            );
          }
        },
        onError: (err) => {
          toast.error(err.response.data.message);
        },
      });
    };

    const handleStartConsultation = (event, type = "desktop") => {
      if (!isSelectedClinic(event)) {
        return;
      }
      const bill_id = event?.billing_status?.id || null;
      if (type === "desktop") {
        const payload = {
          action: "postConsultationData",
          frontend: "True",
          transaction_type: "OPD",
          clinic_id: clinic_id,
          doctor_user: role_id,
          opd_date: moment.utc(event?.start).format("YYYY-MM-DDTHH:mm:ss[Z]"),
          personal_details: event?.user_details?.id,
          slot_id: event?.id,
          status: "draft",
          feature_name: "consultation",
        };
        postConsultation.mutate(payload, {
          onSuccess: (data) => {
            if (data?.data?.id) {
              navigate(
                `/new/patient-options?userId=${event?.user_details?.id}&slotId=${event?.id}&consultationId=${data?.data?.id}&option=ongoingconsultation&bill_id=${bill_id}`
              );
              localStorage.setItem(
                "ongoing_consultations",
                JSON.stringify([
                  `/new/patient-options?userId=${event?.user_details?.id}&slotId=${event?.id}&consultationId=${data?.data?.id}&option=ongoingconsultation&bill_id=${bill_id}`,
                ])
              );
            } else {
              navigate(
                `/new/patient-options?userId=${event?.user_details?.id}&slotId=${event?.id}&consultationId=${data?.consultation_id}&option=ongoingconsultation&bill_id=${bill_id}`
              );
              localStorage.setItem(
                "ongoing_consultations",
                JSON.stringify([
                  `/new/patient-options?userId=${event?.user_details?.id}&slotId=${event?.id}&consultationId=${data?.consultation_id}&option=ongoingconsultation&bill_id=${bill_id}`,
                ])
              );
            }
          },
          onError: () => {
            toast.error("something went wrong");
          },
        });
      } else {
        navigate(
          `/new/patient-options?userId=${event?.user_details?.id}&slotId=${event?.id}&bill_id=${bill_id}`
        );
      }
    };

    const handleDecline = (event) => {
      if (!isSelectedClinic(event)) {
        return;
      }

      const payload = {
        id: event?.id,
        action: "delSlots",
        frontend: "True",
        clinic_id: clinic_id,
      };

      if (event?.id) {
        deleteSlotMutation.mutate(
          { data: payload },
          {
            onSuccess: (data) => {
              toast.success("Slot deleted successfully");
              setIsMobileModal({
                flag: false,
                event: null,
              });
            },
            onError: (error) => {
              toast.error("Failed to delete slot. Please try again.");
            },
          }
        );
      }
    };

    const handleBlock = (e, event) => {
      if (!isSelectedClinic(event)) {
        return;
      }
      const payload = {
        action: "postBlockedSlots",
        block_list: [
          {
            start_time: dateConvertToPayloadBookingFormat(event?.start),
            end_time: dateConvertToPayloadBookingFormat(event?.end),
            status: "blocked",
            doctor_user: role_id,
          },
        ],
        clinic_id: clinic_id,
        frontend: "True",
      };

      blockedSlotMutation.mutate(payload, {
        onSuccess: () => {
          toast.success("Blocked Sucessfully");
        },
        onError: (err) => {
          toast.error(err.response.data.message);
        },
      });
      e.stopPropagation();
    };

    const handleUnBlock = (event) => {
      if (!isSelectedClinic(event)) {
        return;
      }
      const payload = {
        id: event?.id,
        action: "delBlockedSlots",
        frontend: "True",
        clinic_id: clinic_id,
      };

      unblock_mutation.mutate(
        {
          data: payload,
        },
        {
          onSuccess: () => {
            toast.success("Unblocked Sucessfully");
          },
          onError: () => {
            toast.error("please try again");
          },
        }
      );
    };

    const update_mutation = useUpdateItem(ApiEndPoint?.QM_SC_SLOTS);

    const handleNoShow = (event) => {
      if (!isSelectedClinic(event)) {
        return;
      }

      const payload = {
        id: event?.id,
        action: "patchSlots",
        frontend: "True",
        status: "no_show",
        clinic_id: clinic_id,
      };

      update_mutation.mutate(
        { data: payload },
        {
          onSuccess: () => toast.success("Patient No Showed!"),
          onError: () => toast.error("something went wrong"),
        }
      );
    };

    // const checkIsInstitutionPatient = (response) => {
    //   let invoiceUrl = `/new/create_invoice?bill_type=${selectedUser?.type}`;
    //   if (selectedUser?.billing_status?.id) {
    //     invoiceUrl = `/new/create_invoice?editId=${selectedUser?.billing_status?.id}&bill_type=${selectedUser?.type}`;
    //   }
    //   if (response?.data) {
    //     if (selectedUser?.custom_field_1?.value?.length > 0) {
    //       navigate(invoiceUrl, {
    //         state: {
    //           data: {
    //             institution_customer: response?.data,
    //             slot_id: selectedUser?.id || null,
    //             patient_details: {
    //               id: selectedUser?.user_details?.id || null,
    //               full_name: selectedUser?.user_details?.full_name || "",
    //               phone: selectedUser?.user_details?.phone || "",
    //             },
    //             opd: {
    //               id: selectedUser?.opd?.id || null,
    //               opd_number: selectedUser?.opd?.opd_number || "",
    //               date: moment(
    //                 selectedUser?.opd?.opd_date ||
    //                   selectedUser?.opd?.date_created
    //               ).format("DD MMMM YYYY"),
    //             },
    //             admission_details: {
    //               admission_date: "",
    //               admission_time: "",
    //               discharge_date: "",
    //               discharge_time: "",
    //               IPD_No: selectedUser?.ipd?.ipd_number || "",
    //               ipd_id: selectedUser?.ipd?.id || null,
    //               injury_no: selectedUser?.custom_field_1?.value || "",
    //             },
    //           },
    //           isInstitutionP: true,
    //           throwAppointment: true,
    //         },
    //       });
    //     } else {
    //       toast.error(
    //         "Injury number is required as this is an institution patient"
    //       );
    //     }
    //   } else {
    //     navigate(invoiceUrl, {
    //       state: {
    //         data: {
    //           slot_id: selectedUser?.id || null,
    //           patient_details: {
    //             id: selectedUser?.user_details?.id || null,
    //             full_name: selectedUser?.user_details?.full_name || "",
    //             phone: selectedUser?.user_details?.phone || "",
    //             age: selectedUser?.user_details?.age || "",
    //             gender: selectedUser?.user_details?.gender || "",
    //           },
    //           opd: {
    //             id: selectedUser?.opd?.id || null,
    //             opd_number: selectedUser?.opd?.opd_number || "",
    //             date: moment(selectedUser?.opd?.date_created).format(
    //               "DD MMMM YYYY"
    //             ),
    //           },
    //           admission_details: {
    //             admission_date: "",
    //             admission_time: "",
    //             discharge_date: "",
    //             discharge_time: "",
    //             IPD_No: selectedUser?.ipd?.ipd_number || "",
    //             ipd_id: selectedUser?.ipd?.id || null,
    //             injury_no: "",
    //           },
    //         },
    //         isInstitutionP: false,
    //         throwAppointment: true,
    //       },
    //     });
    //   }
    //   setSelectedUser(null);
    // };

    // const { data: institutionData } = useItemsFilterNew(
    //   "payments/billing/",
    //   `?action=getUserInstitution&backend=True&clinic_id=${clinic_id}&user_id=${selectedUser?.user_details?.user}`,
    //   clinic_id && selectedUser?.user_details?.user ? true : false,
    //   checkIsInstitutionPatient,
    //   0
    // );

    const handleCreateInvoice = (type, event) => {
      // if (event?.opd?.id && event?.opd?.opd_number?.length > 0) {
      setIsInvoice({ data: event, flag: true });
      setIsMobileModal({ flag: false, event: null });
      // return;
      // }
      // if (
      //   type === "IPD" &&
      //   event?.ipd?.id &&
      //   event?.ipd?.ipd_number?.length > 0
      // ) {
      //   setSelectedUser({ ...event, type });
      //   return;
      // }
      // if (
      //   type === "OPD" &&
      //   event?.opd?.id &&
      //   event?.opd?.opd_number?.length > 0
      // ) {
      //   let invoiceUrl = `/new/create_invoice?bill_type=${type}`;
      //   if (event?.billing_status?.id) {
      //     invoiceUrl = `/new/create_invoice?editId=${event?.billing_status?.id}&bill_type=${type}`;
      //   }
      //   navigate(invoiceUrl, {
      //     state: {
      //       data: {
      //         slot_id: event?.id || null,
      //         patient_details: {
      //           id: event?.user_details?.id || null,
      //           full_name: event?.user_details?.full_name || "",
      //           phone: event?.user_details?.phone || "",
      //           age: event?.user_details?.age || "",
      //           gender: event?.user_details?.gender || "",
      //         },
      //         opd: {
      //           id: event?.opd?.id || null,
      //           opd_number: event?.opd?.opd_number || "",
      //           date: moment(event?.opd?.date_created).format("DD MMMM YYYY"),
      //         },
      //         admission_details: {
      //           admission_date: "",
      //           admission_time: "",
      //           discharge_date: "",
      //           discharge_time: "",
      //           IPD_No: event?.ipd?.ipd_number || "",
      //           ipd_id: event?.ipd?.id || null,
      //           injury_no: "",
      //         },
      //       },
      //       isInstitutionP: false,
      //       throwAppointment: true,
      //     },
      //   });
      //   return;
      // }
      // toast.error(`${type} number is required`);
    };

    const updateView = (view) => {
      const newParams = new URLSearchParams(searchParams);
      newParams.set("view", view);
      setSearchParams(newParams);
    };

    function onView(newView, newDate) {
      updateView(newView);
    }

    const handleSwipeLeft = () => {
      let newDate;

      switch (dayCycle) {
        case "day":
          newDate = moment(date).add(1, "days").toDate();
          break;
        case "week":
          newDate = moment(date).add(1, "weeks").toDate();
          break;
        case "month":
          newDate = moment(date).add(1, "months").toDate();
          break;

        default:
          newDate = date;
      }

      setDate(newDate);
    };

    const handleSwipeRight = () => {
      let newDate;

      switch (dayCycle) {
        case "day":
          newDate = moment(date).add(-1, "days").toDate();
          break;
        case "week":
          newDate = moment(date).add(-1, "weeks").toDate();
          break;
        case "month":
          newDate = moment(date).add(-1, "months").toDate();
          break;

        default:
          newDate = date;
      }

      setDate(newDate);
    };

    const scrollToCurrentTime = () => {
      const now = new Date();
      const calendarStart = new Date(now);
      calendarStart.setHours(0, 0, 0, 0);
      const timeDifferenceMinutes = (now - calendarStart) / (1000 * 60);
      const scrollPosition = timeDifferenceMinutes * (600 / 60);
      // setScrollPosition(scrollPosition);
      window.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
    };

    useEffect(() => {
      if (dayCycle === "day") {
        scrollToCurrentTime();
      }
      return () => {
        window.scrollTo({
          top: 0,
          behavior: "auto",
        });
      };
    }, [dayCycle]);

    return (
      <div>
        <Swipeable
          onSwipeLeft={handleSwipeLeft}
          onSwipeRight={handleSwipeRight}
        >
          <Calendar
            ref={calendarRef}
            className="custom-rbc-calendar-view"
            localizer={localizer}
            events={dayCycle == "month" ? totalAppointmentsOnMonth : events}
            components={{
              toolbar: (props) => (
                <CustomToolbar
                  {...props}
                  dayCycle={dayCycle}
                  userViewID={userViewID}
                  selectedDoctor={selectedDoctor}
                  selectedSession={selectedSession}
                  setSelectedSession={setSelectedSession}
                  totalAppointments={totalAppointments}
                  events={events}
                  isOpen={isOpen}
                  isSearchOpen={isSearchOpen}
                  setIsSearchOpen={setIsSearchOpen}
                  bookAppointment={setIsOpen}
                  isCustomSession={isCustomSession}
                  setIsCustomSession={setIsCustomSession}
                  customSessionData={customSessionData}
                  setCustomSessionData={setCustomSessionData}
                  isJumpDate={isJumpDate}
                  setIsJumpDate={setIsJumpDate}
                  allClinic={allClinic}
                  setAllClinic={setAllClinic}
                  // sessionOptions={PersonaOptions}
                  connectWebSocket={connectWebSocket}
                />
              ),
              event: (props) => (
                <Events
                  {...props}
                  dayCycle={dayCycle}
                  eventMonth={events}
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  doctorId={role_id}
                  bookAppointment={bookAppointment}
                  setEditDetailModal={setEditDetailModal}
                  setIsReschedule={setIsReschedule}
                  setIsPreconsultation={setIsPreconsultation}
                  isMobileModal={isMobileModal}
                  handleBlock={handleBlock}
                  handleUnBlock={handleUnBlock}
                  handleEditPatient={handleEditPatient}
                  handleDecline={handleDecline}
                  handleReschedule={handleReschedule}
                  handlePreConsultation={handlePreConsultation}
                  handleStartConsultation={handleStartConsultation}
                  handleEndConsultation={handleEndConsultation}
                  handleOpenSlotClick={handleOpenSlotClick}
                  handleNoShow={handleNoShow}
                  setIsMobileModal={setIsMobileModal}
                  clinic_id={clinic_id}
                  allClinic={allClinic}
                  isConsultationLoading={postConsultation.isLoading}
                  handleCreateInvoice={handleCreateInvoice}
                  permission={permission}
                />
              ),
              month: {
                event: EventMonth,
              },

              agenda: {
                event: (props) =>
                  sm ? (
                    <EventAgenda {...props} dayCycle={dayCycle} />
                  ) : (
                    <Events
                      {...props}
                      handleBlock={handleBlock}
                      handleUnBlock={handleUnBlock}
                      handleEditPatient={handleEditPatient}
                      handleDecline={handleDecline}
                      handleReschedule={handleReschedule}
                      handleStartConsultation={handleStartConsultation}
                      handleEndConsultation={handleEndConsultation}
                      isConsultationLoading={postConsultation.isLoading}
                      handleOpenSlotClick={handleOpenSlotClick}
                      handleNoShow={handleNoShow}
                      handleCreateInvoice={handleCreateInvoice}
                      clinic_id={clinic_id}
                      dayCycle={dayCycle}
                      eventMonth={events}
                      doctorId={role_id}
                      allClinic={allClinic}
                      permission={permission}
                    />
                  ),
              },
            }}
            date={date}
            views={{
              month: true,
              day: true,
              week: true,
              agenda: true,
              year: true,
            }}
            step={5}
            timeslots={1}
            defaultView={dayCycle}
            min={selectedSession?.startTime}
            max={selectedSession?.endTime}
            onView={onView}
            onNavigate={(newDate) => {
              setDate(new Date(newDate));
            }}
          />

          {isOpen.flag && (
            <BookEvent
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              onclktime={onclktime}
              events={events}
              selectedDoctorId={role_id}
              clinicOptions={clinicOptions}
              selectedClinicOption={selectedClinicOption}
              setSelectedClinicOption={setSelectedClinicOption}
            />
          )}

          {editDetailModal.flag && (
            <EditPatientDetail
              isOpen={editDetailModal}
              setIsOpen={setEditDetailModal}
            />
          )}

          {isReschedule?.flag && (
            <RescheduleAppointment
              isReschedule={isReschedule}
              setIsReschedule={setIsReschedule}
              role_id={role_id}
            />
          )}

          {isPreconsultation?.flag && (
            <PreConsultation
              setIsPreconsultation={setIsPreconsultation}
              isPreconsultation={isPreconsultation}
            />
          )}

          {isInvoice?.flag && !sm && (
            <CuModal
              closeModal={() => setIsInvoice({ data: null, flag: false })}
            >
              <Invoice
                event={isInvoice?.data}
                onClose={() => setIsInvoice({ data: null, flag: false })}
                setIsPrint={setIsPrint}
                sm={sm}
                doctor_id={role_id}
              />
            </CuModal>
          )}

          {isInvoice?.flag && sm && (
            <CuMobileModal
              isOpen={isInvoice?.flag}
              modalClassName="cu-modal-container h-[99.5%]"
              closeModal={() => setIsInvoice({ data: null, flag: false })}
            >
              <Invoice
                event={isInvoice?.data}
                onClose={() => setIsInvoice({ data: null, flag: false })}
                setIsPrint={setIsPrint}
                sm={sm}
                doctor_id={role_id}
              />
            </CuMobileModal>
          )}
          {/* I removed sm from here  */}
          {isPrint?.flag && (
            <CuModal closeModal={() => setIsPrint({ data: null, flag: false })}>
              <EmailTemplate
                invoiceData={isPrint?.data}
                closeModal={() => setIsPrint({ data: null, flag: false })}
                isPrint={true}
              />
            </CuModal>
          )}

          {isMobileModal?.flag && (
            <EventsSm
              event={isMobileModal?.event}
              isOpen={isMobileModal?.flag}
              closeModal={() => setIsMobileModal({ flag: false, data: null })}
              handleBlock={handleBlock}
              handleUnBlock={handleUnBlock}
              handleEditPatient={handleEditPatient}
              handleDecline={handleDecline}
              handleReschedule={handleReschedule}
              handleStartConsultation={handleStartConsultation}
              handlePreConsultation={handlePreConsultation}
              handleEndConsultation={handleEndConsultation}
              handleOpenSlotClick={handleOpenSlotClick}
              handleNoShow={handleNoShow}
              setIsMobileModal={setIsMobileModal}
              handleCreateInvoice={handleCreateInvoice}
              dayCycle={dayCycle}
              permission={permission}
            />
          )}
          {isSwitchClinic?.flag && (
            <CuModal
              closeModal={() =>
                setIsSwitchClinic({
                  flag: false,
                  clinicId: null,
                })
              }
            >
              <Confirmation
                heading={"Confirmation"}
                onClick={handleSwitchClinic}
                submitBtnText="Yes"
                confirmationText={
                  "This event is not for the selected clinic, so do you want to switch clinic ?"
                }
                onCancel={() =>
                  setIsSwitchClinic({
                    flag: false,
                    clinicId: null,
                  })
                }
              />
            </CuModal>
          )}
        </Swipeable>
      </div>
    );
  }
);

export default MyCalendar;
